import { render, staticRenderFns } from "./candidate-interview-form.vue?vue&type=template&id=182f2fe6&scoped=true"
import script from "./candidate-interview-form.vue?vue&type=script&lang=js"
export * from "./candidate-interview-form.vue?vue&type=script&lang=js"
import style0 from "./candidate-interview-form.vue?vue&type=style&index=0&id=182f2fe6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182f2fe6",
  null
  
)

export default component.exports